import { typeRequestPagination } from '../system/constants'
import { typeCashDesksFilters } from 'model/dashboardCashDesks/dCashDesksReducer';
import { apiClient } from 'model/axiosConfig';

// Type
export type typeCashDesksRequestFilters = {
    filters: {
        active: true,
        store?: {
            name: string[] | null
        },
        posHardwareModel?: string[] | null,
        posHardwareSerialNumber?: string[] | null,
        fiscalCardId?: string[] | null,
        deleted?: boolean | null,
    } | null,
    pageFilter: typeRequestPagination,
    sortFilter?: {
        direction: string,
        column: string
    }
}

//---------------------------------------------------------------------------------------------------------
// Get cashDesk list
export const getCashDeskList = async (payload: {  filters: typeCashDesksFilters, paginationRequest: typeRequestPagination }) => {

    const path = '/product/pos/search'
    const config = {
        headers: {},
    }
    const data: typeCashDesksRequestFilters = {
        filters: {
            active: true
        },
        pageFilter: payload.paginationRequest,
        sortFilter: {
            direction: 'ASC',
            column: 'store'
        }
    }

    if (payload.filters.storeName) data.filters!.store = { name: [ payload.filters.storeName ] }
    if (payload.filters.posHardwareModel) data.filters!.posHardwareModel = [ payload.filters.posHardwareModel ]
    if (payload.filters.posHardwareSerialNumber) data.filters!.posHardwareSerialNumber = [ payload.filters.posHardwareSerialNumber ]
    if (payload.filters.fiscalCardId) data.filters!.fiscalCardId = [ payload.filters.fiscalCardId]

    try {
        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}

